<template>
    <div class="maps-container">
        <ejs-maps id='containerPower' class="map-container home-region-map" ref="mapPowerInstance" fill="#ccc5b9" align="center" :load='load' :tooltipRender='tooltipRender' style='display:block' :zoomSettings='zoomSettings' :legendSettings='legendSettings'>
            <e-layers>
                <e-layer :shapeData='shapeData' :shapePropertyPath='shapePropertyPath' :shapeDataPath='shapeDataPath' :dataSource='dataSource' :shapeSettings='shapeSettings' :tooltipSettings='tooltipSettings'></e-layer>
            </e-layers>
        </ejs-maps>

        <div id="template" style="display:none">
            <div class="toolback">
                <div class="listing2">
                    <center>
                        ${country}
                    </center>
                </div>
                <hr style="margin-top: 2px;margin-bottom:5px;border:0.5px solid #DDDDDD">
                <div>
                    <span class="listing1">Power Contracts : </span><span class="listing2">${powerContracts}</span>
                </div>
                <div style="align-content:center">
                    <span class="listing1">Power Volume : </span><span class="listing2">${powerVolume} GWh</span>
                </div>
                <div style="align-content:center">
                    <span class="listing1">Gas Contracts : </span><span class="listing2">${gasContracts}</span>
                </div>
                <div style="align-content:center">
                    <span class="listing1">Gas Volume : </span><span class="listing2">${gasVolume} GWh</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { MapsPlugin, Legend, Marker, MapsTooltip, MapAjax, Zoom } from '@syncfusion/ej2-vue-maps';

    Vue.use(MapsPlugin);

    export default Vue.extend({
        data: function () {
            return {
                legendSettings: {
                    visible: false
                },
                zoomSettings: {
                    enable: true,
                    mouseWheelZoom: false,
                    pinchZooming: false,
                    zoomFactor: 6
                },
                shapeData: new MapAjax('https://cdn.syncfusion.com/maps/map-data/world-map.json'),
                shapePropertyPath: 'name',
                shapeDataPath: 'name',
                dataSource: this.$store.state.homeVolumeData.homeRegionalMap,
                tooltipSettings: {
                    visible: true,
                    valuePath: 'name',
                    template: '#template'
                },
                shapeSettings: {
                    fill: "#Dae0f2",
                    colorValuePath: 'color',
                    colorMapping: [
                        {
                            color: '#485696'

                        }
                    ]
                }
            }
        },
        provide: {
            maps: [Legend, Marker, MapsTooltip, Zoom]
        },
        methods: {
            load: function (args) {
                let selectedTheme = location.hash.split("/")[1];
                selectedTheme = selectedTheme ? selectedTheme : "Material";
                args.maps.theme = selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1);
            },
            tooltipRender: function (args) {
                if (!args.options.data) {
                    args.cancel = true;
                }
            }
        },
        mounted() {
            //Comment by Haris error console mutation problem, vue wants property like it allready is in ejs-chart
            this.$refs.mapPowerInstance.height = "500px";
            this.$store.commit('setHomeRegionMap', this.$refs.mapPowerInstance);
            //this.$refs.mapPowerInstance.width = "100%";
        }

    })
</script>
<style>
    .dashboard-seo .map-container, .dashboard-seo .maps-container {
        height: 100%;
        width: 100%;
    }

    #containerPower {
      width: 100%;
    }
    .dashboard-seo .markerTemplate {
        font-size: 12px;
        color: white;
        text-shadow: 0px 1px 1px black;
        font-weight: 500
    }

    .toolback {
        width: 200px;
        border-radius: 4px;
        border: 1px #abb9c6;
        background: rgba(53, 63, 76, 0.90);
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.40);
        padding-bottom: 5px;
        padding-top: 10px;
        padding-left: 10px;
        padding-right: 10px;
    }

    .listing1 {
        font-size: 13px;
        color: #ccc5b9;
    }

    .listing2 {
        font-size: 13px;
        color: #ffffff;
        font-weight: 500;
    }
    .maps-container{
        max-width: 100%;
        max-height: 500px;
    }

</style>